import React, {useState} from 'react'
import {Header} from "../../../header/Header";
import {useDispatch, useSelector} from "react-redux";
import {useParams, useNavigate, Link} from "react-router-dom";
import 'animate.css';
import {zynity_api, zynity_website} from "../../../../config/external-routes";
import { Button, Modal } from 'react-bootstrap';
import {MemberAccordion} from "./members/MemberAccordion";
import {MembersContainer} from "./members/MembersContainer";
import {getOrganizationTeam} from "../../../../store/user_organizations/teams/team";
import {setRouteSelectedOrgId, setRouteSelectedTeamId} from "../../../../store/routes";
import {Loading} from "../../../ui/loading/Loading";
import {
  getCnAData,
  setData,
  setDatumIdOpen,
  setDatumIdOpenData
} from "../../../../store/user_organizations/teams/tools/connect_and_align";

export const TeamHeader = ({suffixRoute = '', selected_team_id = '', selected_organization_id = ''}: any) => {
  const dispatch = useDispatch();
  const yii_url = zynity_website.yii_website_url;
  let {organization_id, team_id} = useParams();

  if(selected_team_id != '') {
    team_id = selected_team_id
  }

  if(selected_organization_id != '') {
    organization_id = selected_organization_id
  }

  const [showMaintrax, setShowMaintrax] = useState(false);
  const [showOrganizationTab, setShowOrganizationTab] = useState(true);
  const [activeOrgStatement, setActiveOrgStatement] = useState('why');
  const [activeTeamStatement, setActiveTeamStatement] = useState('purpose');
  const user_organizations_obj = useSelector((state:any) => state.user_organizations);
  const user_organizations = user_organizations_obj.data?.data
  let organization = user_organizations.filter((item:any) => item.id == organization_id)[0];
  let organization_teams = organization.teams;
  let selected_team = organization_teams.filter((team:any) => team.id == team_id)[0];
  const navigate = useNavigate();
  const [showParticipantsModal, setShowParticipantsModal] = useState(false);
  const organization_team = useSelector((state:any) => state.organization_team);

  if(organization_team.isLoading === true || organization_team?.data == '') {
    return <Loading />
  }

  let team_services = organization_team.data.services[0];

  const goToYiiTools = (org_id:any, team_id:any) => {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = `${zynity_website.yii_website_url}/userHome/index`;
    const orgIdInput = document.createElement('input');
    orgIdInput.type = 'hidden';
    orgIdInput.name = 'orgId';
    orgIdInput.value = String(org_id);

    const teamIdInput = document.createElement('input');
    teamIdInput.type = 'hidden';
    teamIdInput.name = 'teamId';
    teamIdInput.value = String(team_id);

    const teamActionInput = document.createElement('input');
    teamActionInput.type = 'hidden';
    teamActionInput.name = 'teamAction';
    teamActionInput.value = String("goToTools");

    form.appendChild(orgIdInput);
    form.appendChild(teamIdInput);
    form.appendChild(teamActionInput);
    document.body.appendChild(form);
    form.submit();
    return false
  }

  const handleChangeOrganization = async ({target}:any) => {
    let new_org_id = target.value;
    let organization = user_organizations.filter((item:any) => item.id == new_org_id)[0];

    let first_team = organization.teams[0];
    let new_team_id = first_team.id;

    //Suites available for React Version
    if(first_team.Suite == 'Executive') {
      console.log("Changed?");
      dispatch(setDatumIdOpen(0));
      dispatch(setDatumIdOpenData(undefined));
      navigate(`/organizations/${new_org_id}/teams/${new_team_id}${suffixRoute}`)
      return false
    }

    //Suites available only in Yii version
    return goToYiiTools(new_org_id, new_team_id)
  }

  const handleChangeOrgTeam = ({target}:any) => {
    let new_team_id = target.value;
    let selected_team = organization_teams.find((team:any) => team.id == new_team_id)

    if(selected_team.Suite == 'Executive') {
      dispatch(setDatumIdOpen(0));
      dispatch(setDatumIdOpenData(undefined));
      dispatch( getOrganizationTeam({organization_id, team_id: new_team_id}) );
      dispatch(getCnAData({organization_id, team_id: new_team_id}))
      navigate(`/organizations/${organization_id}/teams/${new_team_id}/CnA`, {replace: true})
    } else {
      //Suites available only in Yii version
      return goToYiiTools(organization_id, new_team_id)
    }
  }

  const toogleMaintrax = () => {
    if(showMaintrax === true) {
      setShowMaintrax(false);
    } else {
      setShowMaintrax(true);
    }
  }

  const openParticipantsModal = () => {
    setShowParticipantsModal(true)
  }

  const closeParticipantsModal = () => {
    setShowParticipantsModal(false)
  };

  const handleClickFacilitatorLink = (selectedTeamId: string) => {
    const form = document.getElementById(`facilitatorForm${selectedTeamId}`) as HTMLFormElement;
    if (form) {
      form.submit();
    }
  };

  const goToFacilitatorDashboardHandled = (org_id:string, team_id:string) => {
    dispatch(getOrganizationTeam({organization_id:org_id , team_id}) );
    dispatch(setRouteSelectedOrgId(org_id))
    dispatch(setRouteSelectedTeamId(team_id))
    navigate('/facilitator-dashboard')
  }

  return (
    <>
      <Header />
      <div className="row">
        <div className="col-12 mt-0 mb-0 t-lg-4">
          <nav className="navbar navbar-expand-lg  d-flex justify-content-center pt-3" style={{backgroundColor: '#e8e8e8'}}>
            <ul className="orgTeamHeader-navbar d-flex align-items-center">
              {
                organization.image != null &&
                <li className="nav-item mx-2 mt-2 mt-lg-0">
                  <img style={{width: '120px', maxWidth: '120px', padding: 0}} src={zynity_api.download_file + organization.image} alt="Organization Image"/>
                </li>
              }
              <li className="nav-item mx-2 mt-2 mt-lg-0">
                <select className="form-select" style={{fontWeight: 'bold'}} aria-label="Default select example"
                value={organization_id}
                    onChange={handleChangeOrganization}
                >
                  {
                    user_organizations.map((organization:any) => (
                      <option key={organization.id} value={organization.id}>{organization.name}</option>
                    ))
                  }
                </select>
              </li>
              <li className="nav-item mx-2 mt-2 mt-lg-0">
                <select className="form-select" style={{fontWeight: 'bold'}} aria-label="Default select example"
                    value={team_id}
                    onChange={handleChangeOrgTeam}
                >
                  {
                    organization_teams.map((team:any) => (
                      <option key={team.id} value={team.id}>{team.TeamName}</option>
                    ))
                  }
                </select>
              </li>
              <li className="nav-item mx-2 mt-2 mt-lg-0">
                <button type="button" className="btn btn-teal btn-sm rounded-pill"
                    onClick={openParticipantsModal}
                >Participants <span
                  className="badge bg-light text-dark">{selected_team.total_members}</span></button>

                <Modal show={showParticipantsModal} onHide={closeParticipantsModal}>
                  <Modal.Header closeButton>
                    <Modal.Title className='text-muted fs-5'>Participants - Executive Team Team</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <MembersContainer closeModal={closeParticipantsModal} />
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={closeParticipantsModal}>
                      Close
                    </Button>
                  </Modal.Footer>
                </Modal>

              </li>
              <li className="nav-item mx-2 mt-2 mt-lg-0">
                <button type="button" className="btn btn-teal btn-sm rounded-pill" onClick={toogleMaintrax}>Main Trax</button>
              </li>

              {
                selected_team.is_facilitator &&
                <li className="nav-item mx-2 mt-2 mt-lg-0">
                  <img
                    onClick={() => goToFacilitatorDashboardHandled(organization_id, team_id)}
                    data-toggle="tooltip"
                    style={{width: '40px'}}
                    className="team-icons clickable"
                    src={require('../../../../assets/images/FacilitatorIcon.png')}
                    alt="Facilitator Icon"
                  />
                </li>
              }

              {
                selected_team.is_coach &&
                <Link to="/coach">
                  <img src={require('../../../../assets/images/coach_notes_icon.png')} width="40"></img>
                </Link>
              }

            </ul>
          </nav>
        </div>

        <div 
          className={`col-12 mt-0 mb-5 maintrax ${showMaintrax ? 'open' : ''}`}
          style={{backgroundColor: '#e8e8e8'}}
          aria-hidden={!showMaintrax}
         >
            <div style={{background: 'none', margin: 0}}>
              <div style={{margin: '10px', verticalAlign: 'top'}}>
                
                {/* CSS Styles */}
                <style>{`
                  /* Smooth accordion for Main Trax */
                  .maintrax {
                    overflow: hidden;
                    max-height: 0;                /* collapsed */
                    opacity: 0;
                    transform: translateY(-4px);  /* tiny lift on close */
                    transition:
                      max-height .55s ease,
                      opacity .35s ease,
                      transform .55s ease;
                  }

                  .maintrax.open {
                    max-height: 2000px;           /* larger than tallest content */
                    opacity: 1;
                    transform: translateY(0);
                  }

                  /* accessibility: honor reduced motion */
                  @media (prefers-reduced-motion: reduce) {
                    .maintrax, .maintrax.open {
                      transition: none;
                    }
                  }

                  .tabs { margin-top: 20px; }
                  .tab-links { display: flex; justify-content: center; cursor: pointer; }
                  .tab-links a { padding: 4px 8px; background: #f1f1f1; margin-right: 0 5px; text-decoration: none; color: #333; border-radius: 5px 5px 0 0; }
                  .tab-links a.active { background: #fff; border-bottom: 2px solid #007bff; }
                  .tab-content { border: 1px solid #f1f1f1; border-radius: 0 0 5px 5px; padding: 5px; background: #fff; position: relative; z-index: 1000; margin-top: 10px; }
                  .tab { display: none; }
                  .tab.active { display: block; }
                  .custom-tab-nav { list-style-type: none !important; padding: 0 !important; margin: 0 !important; }
                  .custom-tab-nav .nav-link { border: 1px solid transparent; border-radius: 0; margin-bottom: 0; padding: 8px 12px; color: #007bff; }
                  .custom-tab-nav .nav-link.active { border-color: #007bff; background-color: #e9ecef; color: #0056b3; }
                  .custom-tab-content { padding-left: 20px; font-size: 14px; font-style: italic; }
                  .custom-tab-pane { margin-top: 10px !important; }
                  .tab-pane { display: none; }
                  .tab-pane.active { display: block; }
                  .tab-pane.fade { opacity: 0; transition: opacity 0.15s linear; }
                  .tab-pane.fade.show { opacity: 1; }
                  .custom-tab-link { position: relative; padding-right: 20px; }
                  .custom-tab-link.active::after { content: ''; position: absolute; right: 10px; top: 50%; transform: translateY(-50%); border: solid transparent; border-width: 5px 0 5px 5px; border-left-color: black; }
                  .tooltip-statements-question-mark { cursor: pointer; }
                  .tooltip-statements-text { visibility: hidden; width: 250px; font-size: 12px; background-color: #555; color: #fff; text-align: center; padding: 5px 0; border-radius: 6px; position: absolute; z-index: 1001; top: 20px; left: 50%; margin-left: -125px; opacity: 0; transition: opacity 0.3s;}
                  .tooltip-statements-question-mark:hover + .tooltip-statements-text { visibility: visible; opacity: 1; }
                  .custom-tab-nav .nav-link {white-space: nowrap; }
                  .right-pane-scroll {max-height: calc(100vh - 260px); overflow-y: auto;}
                  .right-col {display: flex; flex-direction: column; min-height: 0;}
                  @media (min-width: 768px) {
                    .hide-on-md-lg { display: none; }
                    .right-border-on-md-lg { border-right: 2px solid lightgray; }
                    .custom-tab-content { text-align: left; }
                  }
                  @media (max-width: 768px) {
                    .custom-tab-content { text-align: center; }
                  }
                `}</style>

                {/* Main Trax Tabs */}
                <div className="tabs mt-0" style={{backgroundColor: '#e8e8e8'}}>
                  <div className="tab-links" style={{margin: 0, padding: 0}}>
                    <a href="#tab1" className={showOrganizationTab ? "active" : ""} onClick={(e) => {e.preventDefault(); setShowOrganizationTab(true)}}>Organization</a>
                    <a href="#tab2" className={!showOrganizationTab ? "active" : ""} onClick={(e) => {e.preventDefault(); setShowOrganizationTab(false)}}>Team</a>
                    <div style={{display: 'inline-block', marginTop: '4px', paddingLeft: '10px', position: 'relative'}}>
                      <span className="tooltip-statements-question-mark" style={{color: 'lightgray'}}>?</span>
                      <span className="tooltip-statements-text">
                        The Organization statements are managed by the organization Administrator (Org Profile). The Team statements are managed by the team Facilitator (Team Profile).
                      </span>
                    </div>
                  </div>

                  <div className="tab-content" style={{margin: 0, padding: 0, minHeight: '220px'}}>
                    
                    {/* Organization Tab */}
                    <div id="tab1" className={`tab ${showOrganizationTab ? 'active' : ''}`} style={{margin: 0, padding: '6px'}}>
                      <div className="container flex flex-column mt-1">
                        <div className="row gx-0">
                          <div className="col-sm-4 mt-1">
                            <div className="custom-tab-nav right-border-on-md-lg" id="myCustomTab" role="tablist">
                              
                              {/* Organization Statement Links */}
                              {organization.why && !organization.hide_why_in_main_trax && (
                                <div className="nav-item" role="presentation" style={{height: '32px'}}>
                                  <a className={`nav-link custom-tab-link ${activeOrgStatement === 'why' ? 'active' : ''}`} 
                                     onClick={() => setActiveOrgStatement('why')}>
                                    Why
                                  </a>
                                </div>
                              )}
                              
                              {organization.promise && !organization.hide_promise_in_main_trax && (
                                <div className="nav-item" role="presentation" style={{height: '32px'}}>
                                  <a className={`nav-link custom-tab-link ${activeOrgStatement === 'promise' ? 'active' : ''}`} 
                                     onClick={() => setActiveOrgStatement('promise')}>
                                    Promise
                                  </a>
                                </div>
                              )}
                              
                              {organization.vision && !organization.hide_vision_in_main_trax && (
                                <div className="nav-item" role="presentation" style={{height: '32px'}}>
                                  <a className={`nav-link custom-tab-link ${activeOrgStatement === 'vision' ? 'active' : ''}`} 
                                     onClick={() => setActiveOrgStatement('vision')}>
                                    Vision
                                  </a>
                                </div>
                              )}
                              
                              {organization.mission && !organization.hide_mission_in_main_trax && (
                                <div className="nav-item" role="presentation" style={{height: '32px'}}>
                                  <a className={`nav-link custom-tab-link ${activeOrgStatement === 'mission' ? 'active' : ''}`} 
                                     onClick={() => setActiveOrgStatement('mission')}>
                                    Mission
                                  </a>
                                </div>
                              )}
                              
                              {organization.coreValues && !organization.hide_core_values_in_main_trax && (
                                <div className="nav-item" role="presentation" style={{height: '32px'}}>
                                  <a className={`nav-link custom-tab-link ${activeOrgStatement === 'coreValues' ? 'active' : ''}`} 
                                     onClick={() => setActiveOrgStatement('coreValues')}>
                                    Core Values
                                  </a>
                                </div>
                              )}
                              
                              {organization.cultureStatement && !organization.hide_culture_statement_in_main_trax && (
                                <div className="nav-item" role="presentation" style={{height: '32px'}}>
                                  <a className={`nav-link custom-tab-link ${activeOrgStatement === 'cultureStatement' ? 'active' : ''}`} 
                                     onClick={() => setActiveOrgStatement('cultureStatement')}>
                                    Culture Statement
                                  </a>
                                </div>
                              )}
                              
                            </div>
                          </div>
                          
                          <div className="col-sm-8" style={{display: 'flex', flexDirection: 'column', minHeight: '200px'}}>
                            <hr className="hide-on-md-lg" style={{borderTop: '2px solid lightgray', margin: 0, marginTop: '0', padding: 0}} />
                            <div className="tab-content custom-tab-content" id="myCustomTabContent" style={{border: 'none', margin: 0, padding: 0, paddingBottom: '14px', alignItems: 'center', paddingLeft: '10px'}}>
                              
                              {/* Organization Statement Content */}
                              {activeOrgStatement === 'why' && organization.why && (
                                <div className="tab-pane fade show active custom-tab-pane">
                                  <p dangerouslySetInnerHTML={{__html: organization.why}} />
                                </div>
                              )}
                              
                              {activeOrgStatement === 'promise' && organization.promise && (
                                <div className="tab-pane fade show active custom-tab-pane">
                                  <p dangerouslySetInnerHTML={{__html: organization.promise}} />
                                </div>
                              )}
                              
                              {activeOrgStatement === 'vision' && organization.vision && (
                                <div className="tab-pane fade show active custom-tab-pane">
                                  <p dangerouslySetInnerHTML={{__html: organization.vision}} />
                                </div>
                              )}
                              
                              {activeOrgStatement === 'mission' && organization.mission && (
                                <div className="tab-pane fade show active custom-tab-pane">
                                  <p dangerouslySetInnerHTML={{__html: organization.mission}} />
                                </div>
                              )}
                              
                              {activeOrgStatement === 'coreValues' && organization.coreValues && (
                                <div className="tab-pane fade show active custom-tab-pane">
                                  <p dangerouslySetInnerHTML={{__html: organization.coreValues}} />
                                </div>
                              )}
                              
                              {activeOrgStatement === 'cultureStatement' && organization.cultureStatement && (
                                <div className="tab-pane fade show active custom-tab-pane" style={{ 
                                  maxHeight: 'calc(85vh - 260px)', 
                                  overflowY: 'auto' 
                                  }}>
                                  <p dangerouslySetInnerHTML={{__html: organization.cultureStatement}} />
                                </div>
                              )}
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Team Tab */}
                    <div id="tab2" className={`tab ${!showOrganizationTab ? 'active' : ''}`} style={{margin: 0, padding: '6px', marginBottom: '-30px'}}>
                      <div className="container mt-1">
                        <div className="row">
                          <div className="col-sm-4 mt-1">
                            <div className="custom-tab-nav right-border-on-md-lg" id="myCustomTab" role="tablist" style={{marginTop: '10px !important'}}>
                              <div className="nav-item" role="presentation">
                                <a className={`nav-link custom-tab-link ${activeTeamStatement === 'purpose' ? 'active' : ''}`} 
                                   onClick={() => setActiveTeamStatement('purpose')}>
                                  Purpose
                                </a>
                              </div>
                            </div>
                          </div>
                          
                          <div className="col-sm-8">
                            <hr className="hide-on-md-lg" style={{borderTop: '2px solid lightgray', margin: 0, marginTop: '-4px', padding: 0}} />
                            <div className="tab-content custom-tab-content" id="myCustomTabContent" style={{border: 'none', margin: 0, padding: 0, paddingBottom: '14px', alignItems: 'center'}}>
                              <div className="tab-pane fade show active custom-tab-pane">
                                <p dangerouslySetInnerHTML={{__html: selected_team.Purpose}} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>

      </div>
    </>
  )
}
